<template>
  <div
    v-if="dialog"
    class="download-popup-overlay"
    :class="dialog? 'active':''"
  >
    <div
      v-click-outside="closePopup"
      class="popup"
      :class="showMoreFiles ? 'scroll' : ''"
    >
      <div class="popup-content">
        <h2 class="popup-title">
          Download files
        </h2>
        <h3 class="popup-message">
          Choose the platform to download
        </h3>
        <div class="file-wrapper" :class="showMoreFiles? 'open': ''">
          <div v-for="file in files" :key="file.id" class="popup-file-info">
            <div class="file">
              <div class="file-image">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="15"
                    cy="15"
                    r="15"
                    fill="#FFF0E2"
                  />
                  <path
                    d="M21.5508 12.5891H21.144V10.6265C21.1437 10.614 21.1425 10.6016 21.1404 10.5893C21.141 10.5104 21.1128 10.4341 21.0612 10.3745L17.796 6.64427L17.7936 6.64187C17.774 6.62075 17.7519 6.6022 17.7276 6.58667L17.706 6.57347C17.6853 6.56194 17.6633 6.55269 17.6406 6.54587L17.6226 6.53987C17.5977 6.53366 17.5721 6.53044 17.5464 6.53027H9.5202C9.1536 6.53027 8.856 6.82847 8.856 7.19447V12.5885H8.4492C7.9248 12.5885 7.5 13.0133 7.5 13.5377V18.4745C7.5 18.9983 7.9254 19.4237 8.4492 19.4237H8.856V22.8029C8.856 23.1689 9.1536 23.4671 9.5202 23.4671H20.4798C20.8458 23.4671 21.144 23.1689 21.144 22.8029V19.4237H21.5508C22.0746 19.4237 22.5 18.9989 22.5 18.4745V13.5377C22.5 13.0139 22.0752 12.5891 21.5508 12.5891ZM9.5202 7.19447H17.214V10.5929C17.214 10.7765 17.3628 10.9247 17.5464 10.9247H20.4804V12.5885H9.5202V7.19447ZM14.4894 16.2953C13.683 16.0073 13.1508 15.5609 13.1508 14.8559C13.1508 14.0285 13.8492 13.4027 14.9862 13.4027C15.5406 13.4027 15.936 13.5107 16.224 13.6469L15.9792 14.5247C15.6655 14.3719 15.3208 14.2932 14.9718 14.2949C14.4966 14.2949 14.2662 14.5175 14.2662 14.7623C14.2662 15.0719 14.532 15.2081 15.1656 15.4457C16.0224 15.7625 16.4178 16.2083 16.4178 16.8923C16.4178 17.7059 15.7992 18.3965 14.4678 18.3965C13.9134 18.3965 13.3668 18.2453 13.0932 18.0941L13.3164 17.1947C13.6932 17.387 14.109 17.4905 14.532 17.4971C15.036 17.4971 15.3024 17.2877 15.3024 16.9715C15.3024 16.6691 15.0726 16.4969 14.4894 16.2953ZM8.7738 15.9641C8.7738 14.3159 9.954 13.4021 11.4216 13.4021C11.9904 13.4021 12.4218 13.5167 12.6162 13.6109L12.3858 14.4815C12.0943 14.3591 11.7809 14.2978 11.4648 14.3015C10.6014 14.3015 9.9252 14.8265 9.9252 15.9059C9.9252 16.8701 10.5006 17.4821 11.472 17.4821C11.8104 17.4821 12.1704 17.4179 12.393 17.3237L12.552 18.1871C12.3576 18.2801 11.8968 18.3959 11.3142 18.3959C9.6372 18.3965 8.7738 17.3459 8.7738 15.9641ZM20.4798 22.6241H9.5202V19.4243H20.4798V22.6241ZM19.593 18.3245H18.312L16.758 13.4741H17.9598L18.5496 15.5255C18.7146 16.1081 18.8658 16.6553 18.981 17.2595H19.0026C19.1253 16.6829 19.2716 16.1116 19.4412 15.5471L20.0604 13.4747H21.2256L19.593 18.3245Z"
                    fill="#FF792E"
                  />
                </svg>
              </div>
              <span class="file-descr">Document_1.csv</span>
            </div>
            <span class="file-size">27 MB</span>
            <div class="file-owner">
              <div class="owner-photo">
                <img
                  src="https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png"
                  alt="file-owner-photo"
                >
              </div>
              <span class="owner-name">Anastasia Pohorielova</span>
            </div>
            <div class="popup-close file">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.9997 0.333496C5.54801 0.333496 0.333008 5.5485 0.333008 12.0002C0.333008 18.4518 5.54801 23.6668 11.9997 23.6668C18.4513 23.6668 23.6663 18.4518 23.6663 12.0002C23.6663 5.5485 18.4513 0.333496 11.9997 0.333496ZM17.833 16.1885L16.188 17.8335L11.9997 13.6452L7.81134 17.8335L6.16634 16.1885L10.3547 12.0002L6.16634 7.81183L7.81134 6.16683L11.9997 10.3552L16.188 6.16683L17.833 7.81183L13.6447 12.0002L17.833 16.1885Z"
                  fill="#D7DCE6"
                />
              </svg>
            </div>
          </div>
        </div>
        <button class="other-files" @click="showMoreFiles = !showMoreFiles">
          {{ moreFilesBtnText }}
        </button>
        <div class="download-platforms">
          <div class="download-platform">
            <a href="#!" class="platform-link">
              <img src="../../assets/img/dropbox-icon.svg" alt="download-platform">
            </a>
          </div>
          <div class="download-platform">
            <a href="#!" class="platform-link">
              <img src="../../assets/img/googledrive-icon.svg" alt="download-platform">
            </a>
          </div>
          <div class="download-platform">
            <a href="#!" class="platform-link">
              <img src="../../assets/img/microsoft-team-icon.svg" alt="download-platform">
            </a>
          </div>
        </div>
        <div class="popup-close" @click="closePopup">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.9997 0.333496C5.54801 0.333496 0.333008 5.5485 0.333008 12.0002C0.333008 18.4518 5.54801 23.6668 11.9997 23.6668C18.4513 23.6668 23.6663 18.4518 23.6663 12.0002C23.6663 5.5485 18.4513 0.333496 11.9997 0.333496ZM17.833 16.1885L16.188 17.8335L11.9997 13.6452L7.81134 17.8335L6.16634 16.1885L10.3547 12.0002L6.16634 7.81183L7.81134 6.16683L11.9997 10.3552L16.188 6.16683L17.833 7.81183L13.6447 12.0002L17.833 16.1885Z"
              fill="#D7DCE6"
            />
          </svg>
        </div>
        <button class="btn popup-btn">
          Download
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadFilesPopup',
  props: {
    files: {
      type: Array,
    }
  },
  data() {
    return {
      dialog: false,
      showMoreFiles: false
    };
  },
  computed: {
    moreFilesBtnText() {
      return this.showMoreFiles ? 'roll up' : `${this.files.length - 3} others`;
    }
  },
  methods: {
    openPopup() {
      this.dialog = true;
    },
    closePopup() {
      this.dialog = false;
      this.showMoreFiles = false;
    }
  }
};
</script>

<style scoped>

@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.download-popup-overlay.active {
  animation: show .3s linear;
}

.download-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, .5);
}

.popup {
  padding: 50px 20px 40px 20px;
  width: 100%;
  max-width: 588px;
  min-height: 377px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background-color: var(--white-color);
  border-radius: 30px;
  z-index: 2;
}

.popup.scroll {
  height: 100vh;
  overflow: hidden auto;
}

.popup-title {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  text-align: center;
  margin: 0;
  color: var(--secondary-black-color);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}

.popup-message {
  margin: 19px 0 20px 0;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  color: var(--light-gray);
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}

.popup-close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 23px;
  width: 70px;
  height: 70px;
  cursor: pointer;
}

.popup-close.file {
  position: absolute;
  margin: 0;
  top: 50%;
  transform: translateY(-50%);
  right: 23px;
  padding: 0;
  width: 23px;
  height: 23px;
}

.popup-close svg path {
  transition: .5s all;
}

.popup-close:hover svg path {
  fill: var(--accent-color);
}

.popup-close svg {
  max-width: 100%;
  max-height: 100%;
}

.file-wrapper {
  padding: 10px;
  height: 262px;
  overflow: hidden;
}

.file-wrapper.open {
  height: auto;
  overflow: unset;
}

.popup-file-info {
  padding: 22px 70px 22px 20px;
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-shadow: 0px 0px 15px rgba(5, 51, 48, 0.06);
  border-radius: 5px;
  position: relative;
  transition: .5s all;
  cursor: pointer;
}

.popup-file-info:hover {
  box-shadow: 0px 4px 20px rgba(77, 106, 147, 0.15);
}

.file {
  max-width: 165px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 23px 0 0;
}

.file-image {
  width: 30px;
  height: 30px;
}

.file-descr {
  display: block;
  padding: 0 0 0 9px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 500;
  color: var(--secondary-black-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 160px;
  max-width: calc(100% - 30px);
}

.file-size {
  display: block;
  width: 100%;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 14px;
  color: var(--secondary-text-color);
}

.popup-file-info:last-child {
  margin: 0;
}

.file-owner {
  display: flex;
  width: 100%;
  max-width: 180px;
  justify-content: flex-start;
  align-items: center;
}

.owner-photo {
  width: 20px;
  height: 20px;
}

.owner-name {
  width: 100%;
  max-width: calc(100% - 20px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0 0 9px;
  display: block;
  font-size: 14px;
  line-height: 14px;
  color: var(--secondary-text-color);
}

.popup-btn {
  width: 100%;
  min-width: unset;
  max-width: 140px;
  padding: 13px 27px;
  margin: 35px auto 0;
  background-color: var(--white-color);
  border-color: var(--accent-color);
  color: var(--accent-color);
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  transition: .5s all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.popup-btn:hover {
  background-color: var(--accent-color);
  color: var(--white-color);
}

.other-files {
  display: block;
  width: 100%;
  max-width: 95px;
  text-align: center;
  padding: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: .5px solid var(--case-btn-border-color);
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  color: var(--light-gray);
  border-radius: 40px;
  background-color: var(--white-color);
  cursor: pointer;
  transition: .5s all;
  margin: 10px 0 0 0;
}

.other-files:hover {
  border-color: var(--accent-color);
  color: var(--accent-color);
}

.download-platforms {
  margin: 40px 0 0 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.download-platform {
  border: .5px solid transparent;
  width: 170px;
  height: 89px;
  border-radius: 5px;
  box-shadow: 0px 0px 15px rgba(5, 51, 48, 0.06);
  transition: .5s all;
  cursor: pointer;
}

.platform-link {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

.download-platform:hover {
  border-color: var(--accent-color);
  box-shadow: 0px 4px 20px rgba(77, 106, 147, 0.15);
}
</style>